var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-toolbar',{attrs:{"color":"white darken-4"}},[_c('v-toolbar-title',[_vm._v("Pagamento "+_vm._s(_vm.payment.uuid))]),_c('v-spacer')],1),_c('payment-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }